module.exports = __webpack_public_path__ + "img/mixedmartialarts-dark.1fba2f0b.svg";